module.exports = __webpack_public_path__ + "static/media/Bulletin.a6026ed3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/LandingPage/images/Bulletin.svg
// module id = 945
// module chunks = 0